export default {"src":"/_next/static/media/section7-icon2.4603caf0.svg","height":72,"width":70,"blurWidth":0,"blurHeight":0};